<script setup>
const props = defineProps({
  metric: {
    type: Object,
    required: true,
  },
})

const pieStyle = computed(() => ({
  background: `conic-gradient(#22c55e 0 ${props.metric.rate}%, #3b82f6 ${props.metric.rate}% 100%)`,
}))
</script>

<template>
  <VCard class="review-widget execution-widget">
    <VCardText class="pa-5">
      <div class="d-flex align-center justify-space-between gap-4 mb-4">
        <div>
          <div class="text-overline text-primary mb-1">{{ $t('dashboard.weeklyReview.executionOverline') }}</div>
          <h2 class="text-h6 font-weight-bold mb-0">{{ $t('dashboard.weeklyReview.capacityReality') }}</h2>
        </div>
        <VIcon icon="mdi-chart-donut" color="primary" size="28" />
      </div>

      <div class="execution-content">
        <div class="execution-pie" :style="pieStyle">
          <div class="execution-pie-inner">
            <strong>{{ metric.rate }}%</strong>
            <span>{{ $t('dashboard.weeklyReview.executionRate') }}</span>
          </div>
        </div>

        <div class="execution-copy">
          <p class="text-body-2 mb-3">
            You planned <strong>{{ metric.planned }}</strong> tasks this week. You completed
            <strong class="text-success">{{ metric.completed }}</strong> and left
            <strong class="text-info">{{ metric.unfinished }}</strong> unfinished.
          </p>
          <VAlert density="compact" variant="tonal" :color="metric.rate < 60 ? 'warning' : 'success'">
            {{ metric.insight }}
          </VAlert>
        </div>
      </div>
    </VCardText>
  </VCard>
</template>

<style scoped lang="scss">
.review-widget {
  block-size: 100%;
  border: 1px solid rgba(var(--v-border-color), 0.12);
  border-radius: 18px;
  background:
    linear-gradient(180deg, rgba(var(--v-theme-surface), 0.86), rgba(var(--v-theme-surface), 0.64)),
    rgba(8, 12, 20, 0.72);
  backdrop-filter: blur(14px) saturate(1.1);
}

.execution-content {
  display: grid;
  grid-template-columns: 160px 1fr;
  align-items: center;
  gap: 22px;
}

.execution-pie {
  display: grid;
  inline-size: 152px;
  block-size: 152px;
  place-items: center;
  border-radius: 50%;
  box-shadow: 0 18px 40px rgba(0, 0, 0, 0.26);
}

.execution-pie-inner {
  display: grid;
  inline-size: 104px;
  block-size: 104px;
  place-items: center;
  border-radius: 50%;
  background: rgb(var(--v-theme-surface));
  text-align: center;

  strong {
    font-size: 1.8rem;
    line-height: 1;
  }

  span {
    color: rgba(var(--v-theme-on-surface), 0.58);
    font-size: 0.72rem;
  }
}

.execution-copy {
  min-inline-size: 0;
}

@media (max-width: 680px) {
  .execution-content {
    grid-template-columns: 1fr;
  }
}
</style>
